// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + (chunkId === 85 ? "lazy-app" : chunkId) + "." + {"85":"369919b4a472bfaf88ad","703":"afc5543522fab1065602"}[chunkId] + ".js";
};